<div
  class="zoomable-photo flex flex-col items-stretch gap-2 w-full"
  style="max-width: min(88vw, 56rem)"
  (mousedown)="onToolbarPointer($event)"
  (click)="onToolbarPointer($event)"
>
  <div class="zoomable-photo__toolbar flex justify-center items-center gap-1" role="toolbar" aria-label="Ovládání fotky">
    <button
      type="button"
      class="btn btn-ghost btn-icon btn-sm"
      [disabled]="!canGoPrev"
      [class.invisible]="!gallery || gallery.length < 2"
      (click)="goPrev($event)"
      aria-label="Předchozí fotka"
      title="Předchozí fotka"
    >
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
      </svg>
    </button>
    <button
      type="button"
      class="btn btn-ghost btn-icon btn-sm"
      (click)="rotateLeft($event)"
      aria-label="Otočit doleva"
      title="Otočit doleva (L)"
    >
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12a9 9 0 0115.5-6.36M3 5v5h5" />
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12a9 9 0 0014.5 5.5" opacity="0.35" />
      </svg>
    </button>
    <button
      type="button"
      class="btn btn-ghost btn-icon btn-sm"
      [disabled]="!canZoomOut"
      (click)="zoomOut($event)"
      aria-label="Oddálit"
      title="Oddálit"
    >
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4" />
      </svg>
    </button>
    <button
      type="button"
      class="btn btn-ghost btn-icon btn-sm"
      [disabled]="!canZoomIn"
      (click)="zoomIn($event)"
      aria-label="Přiblížit"
      title="Přiblížit"
    >
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
      </svg>
    </button>
    <button
      type="button"
      class="btn btn-ghost btn-icon btn-sm"
      [disabled]="!isZoomed"
      (click)="resetZoom($event)"
      aria-label="Resetovat přiblížení"
      title="Resetovat přiblížení"
    >
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8V4h4M20 8V4h-4M4 16v4h4M20 16v4h-4" />
      </svg>
    </button>
    <button
      type="button"
      class="btn btn-ghost btn-icon btn-sm"
      (click)="rotateRight($event)"
      aria-label="Otočit doprava"
      title="Otočit doprava (R)"
    >
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 00-15.5-6.36M21 5v5h-5" />
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 01-14.5 5.5" opacity="0.35" />
      </svg>
    </button>
    <button
      type="button"
      class="btn btn-ghost btn-icon btn-sm"
      [disabled]="!canGoNext"
      [class.invisible]="!gallery || gallery.length < 2"
      (click)="goNext($event)"
      aria-label="Další fotka"
      title="Další fotka"
    >
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
      </svg>
    </button>
  </div>

  <div
    #viewport
    class="zoomable-photo__viewport relative w-full overflow-hidden rounded-lg"
    [ngClass]="cursorClass"
    style="height: min(70vh, 36rem); touch-action: none; user-select: none"
    (pointerdown)="onPointerDown($event)"
    (pointermove)="onPointerMove($event)"
    (pointerup)="onPointerUp($event)"
    (pointercancel)="onPointerUp($event)"
    (dblclick)="onDoubleClick($event)"
  >
    <div class="zoomable-photo__rotator" [style.transform]="rotationCss">
      <img
        [src]="src"
        [alt]="alt"
        class="zoomable-photo__img block w-full h-full object-contain"
        style="transform-origin: 0 0; pointer-events: none"
        [style.transform]="transformCss"
        draggable="false"
      />
    </div>
  </div>
</div>
